__webpack_require__.p = "https://upptic-dev-dashboard.s3.us-east-2.amazonaws.com/framework/v2.7.10-dev/";